import React from 'react';
import { NavLink } from 'react-router-dom';
import styles from './index.module.scss';

import { UiKit } from 'components';

export default function Link({
  shepherdId = '',
  to = '/',
  isLocked = false,
  isExternal = false,
  target = '_blank',
  children = null
}) {
  if (isLocked) {
    return (
      <UiKit.Tooltip>
        <UiKit.Tooltip.Trigger className="w-100">
          <div data-shepherd={shepherdId} className={styles.lockedLink}>
            {children}
          </div>
        </UiKit.Tooltip.Trigger>
        <UiKit.Tooltip.Content
          trigger="click"
          placement="right"
          boundariesElement="viewport"
        >
          You do not have permission to access this part of the portal. Please
          contact your admin for further help.
        </UiKit.Tooltip.Content>
      </UiKit.Tooltip>
    );
  }

  if (isExternal) {
    return (
      <a
        data-shepherd={shepherdId}
        className={styles.link}
        href={to}
        target={target}
      >
        {children}
      </a>
    );
  }

  return (
    <NavLink
      to={to}
      data-shepherd={shepherdId}
      className={styles.link}
      activeClassName={styles.active}
    >
      {children}
    </NavLink>
  );
}
